<template>
    <div id="map-container">
        <h1>Cyber Social Security</h1>
    </div>

    <div v-if="loading" class="loading">
        <div class="loading-text">
            Caricamento...
        </div>
        <p class="spinner-border text-dark" role="status">
            <span class="visually-hidden">Loading...</span>
        </p>
    </div>
    <div v-else>
        <div class="container">
            <!-- BOTTONI PRIMA DELLA MAPPA -->
            <div class="d-flex flex-wrap justify-content-center my-4 gap-3">
                <button class="btn btn-outline-primary" type="button" data-bs-toggle="collapse"
                        data-bs-target="#sezioneCSS" v-if="rankingStreets">
                    🛡️ Indice di Cyber Social Security (CSS)
                </button>
                <button class="btn btn-outline-primary" type="button" data-bs-toggle="collapse"
                        data-bs-target="#sezioneHP" v-if="css_hp">
                    👤 Confronto tra CSS e Human Perception
                </button>
            </div>
        </div>

        <div v-if="rankingStreets && css_hp">
            <p class="container alert alert-info">
                ⬆️ Clicca sui tasti per visualizzare i dati relativi al Cyber Social Security (CSS) o il confronto con i
                dati dello Human Perception ⬆️
            </p>

            <p class="container alert alert-warning">
                ⚠️ Nota bene: i dati visualizzati sono del 2024 e parte del 2025 ⚠️
            </p>
        </div>

        <hr>
        <div id="cssAccordion">
            <div v-if="rankingStreets" class="collapse show" id="sezioneCSS" data-bs-parent="#cssAccordion">
                <div class="card card-body">
                    <div class="legend-container" v-if="rankingStreets">
                        <h3>Interpretazione dei risultati</h3>
                        <p>Gli score assegnati sono spiegati di seguito:</p>
                        <table class="table">
                            <tbody>
                            <tr>
                                <th id="step-a" class="step"><b>A</b></th>
                                <td>Sicuro</td>
                            </tr>
                            <tr>
                                <th id="step-b" class="step"><b>B</b></th>
                                <td>Abbastanza sicuro</td>
                            </tr>
                            <tr>
                                <th id="step-c" class="step"><b>C</b></th>
                                <td>Moderatamente sicuro</td>
                            </tr>
                            <tr>
                                <th id="step-d" class="step"><b>D</b></th>
                                <td>Poco sicuro</td>
                            </tr>
                            <tr>
                                <th id="step-e" class="step"><b>E</b></th>
                                <td>Per niente sicuro</td>
                            </tr>
                            <tr>
                                <th id="step-null" class="step"><b>--</b></th>
                                <td>Non disponibile</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="table-container">
                        <h3>Indice di Cyber Social Security (CSS)</h3>
                        <div v-if="rankingStreets">
                            <div v-if="Object.keys(rankingStreets).length">
                                <DataTable class="table table-bordered table-hover table-responsive pois-table"
                                           :key="streetTableKey" :options="options">
                                    <thead>
                                    <tr>
                                        <th v-for="key in columns_css" :key="key">
                                            {{ key }}
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="data in rankingStreets" :key="data">
                                        <td v-for="key in columns_css" :key="key">
                                            {{ data[key] }}
                                        </td>
                                    </tr>
                                    </tbody>
                                </DataTable>
                            </div>
                        </div>
                        <p v-else>Non ci sono dati disponibili.</p>
                    </div>
                </div>
            </div>

            <div v-if="css_hp" class="collapse" id="sezioneHP" data-bs-parent="#cssAccordion">
                <div class="card card-body">
                    <div class="table-container">
                        <h3>Confronto di livello di sicurezza tra Human Perception e CSS</h3>
                        <div v-if="css_hp">
                            <div v-if="Object.keys(css_hp).length">
                                <DataTable class="table table-bordered table-hover table-responsive pois-table"
                                           :key="streetTableKey" :options="options">
                                    <thead>
                                    <tr>
                                        <th v-for="key in columns_css_hp" :key="key">
                                            {{ key }}
                                        </th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr v-for="data in css_hp" :key="data">
                                        <td v-for="key in columns_css_hp" :key="key">
                                            {{ data[key] }}
                                        </td>
                                    </tr>
                                    </tbody>
                                </DataTable>
                            </div>
                        </div>
                        <p v-else>Non ci sono dati disponibili.</p>
                    </div>
                </div>
            </div>

        </div>
    </div>

</template>


<script>
import DataTable from 'datatables.net-vue3';
import DataTablesCore from 'datatables.net';
import 'datatables.net-responsive';
import 'datatables.net-select';
import {useHead} from "@vueuse/head";

DataTable.use(DataTablesCore);

export default {
    components: {DataTable},
    setup() {
        useHead({
            title: 'InfoNav - Cyber Social Security'
        });
    },
    data() {
        return {
            loading: false,
            year: new Date().getFullYear(),
            forceOverwrite: true,
            rankingStreets: null,
            css_hp: null,
            columns_css: [],
            columns_css_hp: [],
            options: {
                responsive: true,
                select: false,
                order: [[0, 'asc']],
                language: {
                    url: 'https://cdn.datatables.net/plug-ins/1.13.1/i18n/it-IT.json'
                },
                // drawCallback: function () {
                //     const final_index_td = document.getElementsByClassName("final-index");
                //     for (let i = 0; i < final_index_td.length; i++) {
                //         let inner_text = final_index_td[i].innerText.trim();
                //         if (inner_text == "A") {
                //             final_index_td[i].classList.add('index-a');
                //         } else if (inner_text == "B") {
                //             final_index_td[i].classList.add('index-b');
                //         } else if (inner_text == "C") {
                //             final_index_td[i].classList.add('index-c');
                //         } else if (inner_text == "D") {
                //             final_index_td[i].classList.add('index-d');
                //         } else if (inner_text == "E") {
                //             final_index_td[i].classList.add('index-e');
                //         }
                //     }
                // }
            },
        }
    },
    methods: {
        async getData() {
            this.loading = true;
            if (this.year == new Date().getFullYear()) {
                this.forceOverwrite = true;
            } else {
                this.forceOverwrite = false;
            }
            try {
                const response = await fetch(`/api/css/`, {
                    method: 'GET',
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.json();

                await this.$nextTick();

                this.rankingStreets = data['final_rank'];
                this.css_hp = data['css_hp'];
                this.columns_css = data['columns_css'];
                this.columns_css_hp = data['columns_css_hp'];
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                this.loading = false;
            }
        }
    },
    computed: {
        streetTableKey() {
            return `street-${this.year}-${this.dataVersion}`;
        }
    },
    mounted() {
        this.getData();
    }
}
</script>


<style scoped>
body {
    display: flex;
    flex-direction: column;
    font-family: "Poppins", sans-serif !important;
    font-size: large !important;
}

ul {
    display: flex;
    justify-content: space-evenly;
    padding-left: 0%;
    margin: 0;
    width: -webkit-fill-available;
}

li {
    list-style: none;
    width: -webkit-fill-available;
    text-align: center;
}

li.nav-item:hover {
    background-color: #b7defb;
    border-radius: var(--bs-nav-pills-border-radius);
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
    color: white !important;
}

a {
    margin-left: auto;
    text-decoration: none !important;
}

#key p {
    margin: 0;
    margin-left: 1%;
    margin-right: 1%;
    margin-top: 1%;
}

#key h4 {
    margin: 0;
    margin-top: 1%;
}


#n-accident p {
    font-size: smaller;
}

html,
body {
    margin: 0;
    padding: 0;
}

@media (max-height: 40em) {
    h1 {
        font-size: 1.5em;
    }
}

.alert {
    text-align: center !important;
}

.step {
    color: black;
    border: solid black;
    border-width: 2px;
}

/* Best */
#step-a {
    background-color: deepskyblue;
}

#step-b {
    background-color: lightgreen;
}

#step-c {
    background-color: yellow;
}

#step-d {
    background-color: orange;
}

/* Worst */
#step-e {
    background-color: lightcoral !important;
}

#step-null {
    background-color: lightgray !important;
}


.table-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 30px;
}

.table-category {
    margin-bottom: 40px;
}

.table-category h3 {
    text-align: center;
    margin-bottom: 15px;
    color: #007bff;
}

.table th,
.table td {
    text-align: center;
    vertical-align: middle;
}

.table thead th {
    background-color: #007bff;
    color: white;
    font-weight: bold;
}

.legend-container {
    background-color: #f8f9fa;
    border-radius: 8px;
    padding: 15px;
    margin: 30px auto;
}

.legend-container h3 {
    text-align: center;
    color: #007bff;
    margin-bottom: 20px;
}

#map-container {
    display: flex;
    flex-direction: column;
    margin-top: 30px;
}

#map-container h1 {
    text-align: center;
    margin-bottom: 20px;
    color: #007bff;
}

.pollutant-info span {
    display: inline-block;
}

.loading {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.loading-text {
    margin-bottom: 1rem;
}


.year-selector-container h2 {
    margin-bottom: 15px;
}

</style>